import { INewsItem } from "@hulanbv/afbouwkeur-packages";
import { CrudService } from "./crudService.abstract.service";

export const newsService = new (class Service extends CrudService<INewsItem> {
  constructor() {
    super("news");
  }
})();
